import React, { FunctionComponent } from 'react'
import { DescriptionList } from '@vwfs-bronson/bronson-react'

export type DescriptionListGroupProps = {
  termText: any,
  detail: any,
}

const DescriptionListGroup: FunctionComponent<DescriptionListGroupProps> = props => {
  const { termText, detail } = props;

  return (
    <DescriptionList.Group
        termText={termText}
        key={termText}
    >
        <DescriptionList.Detail>
            {detail}
        </DescriptionList.Detail>
    </DescriptionList.Group>
    )
}

export default DescriptionListGroup;